// extracted by mini-css-extract-plugin
export default {"container":"style_container__SFT3C","containerVertical":"style_containerVertical__gUeGF","player":"style_player__HFkpl","spinnerContainer":"style_spinnerContainer__y6qxc"};